import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { TranslateModule } from "@ngx-translate/core";
import { PipesModule } from "src/app/common/pipes/pipes.module";
import { ConfigAreaConfirmDialogComponent } from "./confirm.component";

const materialModules = [
  MatDialogModule,
  MatButtonModule,
  MatIconModule,
  MatCheckboxModule,
  MatInputModule,
  MatFormFieldModule,
  MatDividerModule,
  MatListModule
];

@NgModule({
  declarations: [ConfigAreaConfirmDialogComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, PipesModule, ...materialModules]
})
export class ConfigAreaConfirmDialogModule {}
